import { render } from "./editCompanyDoc.vue?vue&type=template&id=5bd4645a&scoped=true"
import script from "./editCompanyDoc.vue?vue&type=script&lang=js"
export * from "./editCompanyDoc.vue?vue&type=script&lang=js"

import "./editCompanyDoc.vue?vue&type=style&index=0&id=5bd4645a&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd4645a"]])

export default __exports__